/* 
 * CALS AddThis functionality
 */
import { App } from './desertland.app';

declare var log, info, warn, groupCollapsed, groupEnd;

const SELECTOR = '.addthis_sharing_toolbox';

export const AddThis = {

  showLogs: false,

  selector: SELECTOR,

  // Reload (or initialize) addThis social share buttons.
  reload() {
    if (!(window as any).addthis) {
      // Load addThis, if it hasn't already been loaded.

      (window as any).addthis_config = {
        data_track_addressbar: false,
        pubid: 'ra-579107258c57abf0'
      };
      $('body').append('<script type="text/javascript" src="//s7.addthis.com/js/300/addthis_widget.js"></script>');
    }
    if (!(window as any).addthis_share) {
      (window as any).addthis_share = {};
      // http://www.addthis.com/academy/changes-to-how-twitter-works-with-addthis/
      // addthis_share.passthrough : {
      //     twitter: {
      //         via: "TWITTER USERNAME", //“via @”
      // text: "TEXT" //text you’d like to post with the URL
      //     }
      // }
    }
  },

  refresh(options: any = {}) {
    groupCollapsed("Addthis.refresh");
    info("Addthis.refresh > options= %o", options);


    // let sel = options && options.sel ? options.sel : SELECTOR;
    // info("sel length:",$(sel).length);

    this.reload();// verify it's there 

    if ((window as any).addthis) {
      // warn("Addthis.refresh > sel=",sel);
      // (window as any).addthis.toolbox(sel);//.addthis_toolbox');

      //(window as any).addthis.toolbox();//$(this.selector));//.addthis_toolbox');
      if ((window as any).addthis.layers && typeof (window as any).addthis.layers.refresh === "function") {
        (window as any).addthis.layers.refresh(); // http://www.addthis.com/academy/using-dashboard-configuration-tools-dynamically/
      }

      info('addthis_share: %o', (window as any).addthis_share);
      info('addthis: %o', (window as any).addthis);
    } else {
      console.error("Where'd addThis go? ...where'd who go?");
    }

    groupEnd("Addthis.refresh");
  },

  update(options = {}) {
    groupCollapsed("Addthis.update");
    log("Addthis.update > options= %o", options);

    this.reload();// verify it's there 

    if (!App.shareUrl) {
      App.shareUrl = (App.currentPage !== "index") ? App.currentPage + "/" : "";
      // warn("reset !App.shareUrl: %s", App.shareUrl);
    }
    info("App.shareUrl: '%s' && gaTitle: '%s'", App.shareUrl, App.gaTitle);

    this.updateFooterEl();

    if ((window as any).addthis) {

      /* sure to be loaded at this point.. re-attach it to the newly rendered set of social icons.
       And reset share url/title, so they don't carry-over from the previous page.
       http://www.addthis.com/academy/setting-the-url-title-to-share/ */
      // (window as any).addthis_share = (window as any).addthis_share || {};
      // (window as any).addthis_share.url = App.config.prodPath + App.shareUrl;
      // (window as any).addthis_share.title = DESERTLAND.gaTitle;
      // v2 - dynamic, hardly documented!
      /* http://stackoverflow.com/questions/16357422/addthis-widget-js-throwing-cannot-read-property-pmh-of-null-error-on-android
          Type is either "share" or "config". The key is the same key you would set according to our API documentation. 
          What you likely need to know are just the two keys: "url" and "title". The value is of course the value you want those options to have. */
      (window as any).addthis.update("share", "url", App.config.prodPath + App.shareUrl);
      (window as any).addthis.update("share", "title", App.gaTitle);

      // try the more dynamic route - addthis transforms
      // http://www.addthis.com/academy/adding-parameters-to-urls/
      //error(Boolean(DESERTLAND.shareArgs), Boolean(Object.keys(DESERTLAND.shareArgs).length > 0));
      // error("why can we not pick up these url_transforms?!?!");
      //             if (false && DESERTLAND.shareArgs && Object.keys(DESERTLAND.shareArgs).length > 0) {
      //                 warn('DESERTLAND.shareArgs: %o',DESERTLAND.shareArgs);
      //                 //info('addthis: %o',(window as any).addthis);
      //                 warn('addthis_share: %o',(window as any).addthis_share);
      //                 // let url_transforms = (window as any).addthis_share.url_transforms || {};//$.extend(true, {}, (window as any).addthis_share.url_transforms);
      //                 // if (!url_transforms.add) { url_transforms.add = {} };
      //                 (window as any).addthis_share.url_transforms = (window as any).addthis_share.url_transforms || {};
      //                 (window as any).addthis_share.url_transforms.add = (window as any).addthis_share.url_transforms.add || {};
      //                 for (var key in DESERTLAND.shareArgs) {
      //                     if (DESERTLAND.shareArgs.hasOwnProperty(key)) {
      //                         (window as any).addthis_share.url_transforms.add[key] = DESERTLAND.shareArgs[key];
      //                     }
      //                 }
      //                 (window as any).addthis_share.url_transforms.add.share = App.currentPage;
      //                 (window as any).addthis_share.url_transforms.add.referrer = '{{code}}'; //http://www.addthis.com/academy/adding-parameters-to-urls/

      //                 warn((window as any).addthis_share.url_transforms.add);
      //                 //(window as any).addthis.update("share", "url_transforms", url_transforms);
      //                 //(window as any).addthis_share.url_transforms = url_transforms;
      //             } else {
      //                 info('shareArgs not found: %o',DESERTLAND.shareArgs);
      //             }




      // if ((window as any).addthis.layers && typeof (window as any).addthis.layers.refresh === "function") {
      //     (window as any).addthis.layers.refresh(); // http://www.addthis.com/academy/using-dashboard-configuration-tools-dynamically/
      // } else {
      //     warn("!addthis.layers.refresh");
      //     // (window as any).addthis.toolbox(this.selector);//.addthis_toolbox');
      // }
      (window as any).addthis.toolbox(SELECTOR);//.addthis_toolbox');

      log('addthis_share: %o addthis: %o', (window as any).addthis_share, (window as any).addthis);
    } else {
      console.error("Where'd addThis go? ...where'd who go?");
    }


    groupEnd("Addthis.update");
  },

  updateFooterEl() {
    this.updateShareEl('.footer-share-box');
  },

  updateShareEl(sel) {
    // groupCollapsed("updateShareEl");
    sel = sel || SELECTOR;
    let shareWrap = $(sel);
    if (shareWrap.length) {

      // set both data and attr for testing - should only need .data() ?
      shareWrap.attr({
        'data-url': App.config.prodPath + App.shareUrl,
        'data-title': App.gaTitle
      }).data({
        url: App.config.prodPath + App.shareUrl,
        title: App.gaTitle
      });

      // groupEnd("updateShareEl");
    } else {
      info("updateShareEl > no addthis wrap yet, wait for tpl radio", sel);
      // groupEnd("updateShareEl");
      App.radio.unsubscribe('tpl:footer:ready', this.updateShareEl);
      App.radio.subscribe('tpl:footer:ready', this.updateShareEl);
    }
  }

};



